import { isNullOrUndef } from "./object";

export function isEmptyString(value: string): boolean {
    return isNullOrUndef(value) || value === "";
}
